
const Manager = () => import('../views/System/manager/index');
const AuthRule = () => import('../views/System/auth/authRule/index');
const AuthGroup = () => import('../views/System/auth/authGroup/index');
const Area = () => import('../views/System/area/index.vue');

export default [
  {
    path: '/authRule',
    name: '权限规则',
    component: AuthRule,
    meta: [{ name: '权限规则' }]
  },
  {
    path: '/authGroup',
    name: '用户角色',
    component: AuthGroup,
    meta: [{ name: '用户角色' }]
  },
  {
    path: '/area',
    name: '大区管理',
    component: Area,
    meta: [{ name: '大区管理' }]
  },
  {
    path: '/manager',
    name: '管理员维护',
    component: Manager,
    meta: [{ name: '管理员维护' }]
  },
];
